import * as R from 'ramda';

import { Resort } from './resort';
import { IAppState } from '../core/redux/IAppState';
import ImmutableMap from '../language/ImmutableMap';


export const getGlobalAndLocalResortList = (state: IAppState ) : Resort[] => {

  const globalResort = (R.path<ImmutableMap<Resort>>([ 'resortDetails', 'allResorts' ], state)
    || ImmutableMap.empty()).get('ALL');
  const currentResort = state.selectedResort;

  return currentResort ? [ globalResort, currentResort ] : [ globalResort ];

}
